import React from 'react';
import { Modal, Button, Form, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Formik } from 'formik';
import moment from 'moment';
import periodoSchema from '../schema';

// W-0570 — Matricial de Despesas — Períodos
// DataIni/DataFim ficam disabled quando tem_itens === true (PROMPT §8)

const toInputDate = (valor) =>
  valor ? moment(valor).format('YYYY-MM-DD') : '';

const FormPeriodo = ({ show, periodo, onFechar, onSalvar, salvando }) => {
  const edicao = !!(periodo && periodo.codigo);
  const temItens = edicao && !!(periodo && periodo.tem_itens);

  const valoresIniciais = {
    descricao: (periodo && periodo.descricao) ? periodo.descricao : '',
    data_ini: (periodo && periodo.data_ini) ? toInputDate(periodo.data_ini) : '',
    data_fim: (periodo && periodo.data_fim) ? toInputDate(periodo.data_fim) : '',
    data_limite: (periodo && periodo.data_limite) ? toInputDate(periodo.data_limite) : '',
  };

  const handleSubmit = (values) => {
    const payload = {
      descricao: values.descricao,
      data_limite: values.data_limite ? values.data_limite : null,
    };
    if (!temItens) {
      payload.data_ini = values.data_ini;
      payload.data_fim = values.data_fim;
    }
    onSalvar(payload);
  };

  const campoDatasTooltip = (
    <Tooltip id="tooltip-datas-bloqueadas">
      Datas não podem ser alteradas — período possui lançamentos
    </Tooltip>
  );

  return (
    <Modal show={show} onHide={onFechar} centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{edicao ? 'Editar Período' : 'Novo Período'}</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={valoresIniciais}
        validationSchema={periodoSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit: formikSubmit }) => (
          <Form noValidate onSubmit={formikSubmit}>
            <Modal.Body>
              <Form.Group controlId="descricao" className="mb-3">
                <Form.Label>Descrição</Form.Label>
                <Form.Control
                  type="text"
                  name="descricao"
                  maxLength={50}
                  value={values.descricao}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.descricao && !!errors.descricao}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.descricao}
                </Form.Control.Feedback>
              </Form.Group>

              <Row>
                <Col xs={12} md={6}>
                  <Form.Group controlId="data_ini" className="mb-3">
                    <Form.Label>Data Inicial *</Form.Label>
                    {temItens ? (
                      <OverlayTrigger placement="top" overlay={campoDatasTooltip}>
                        <div>
                          <Form.Control
                            type="date"
                            name="data_ini"
                            value={values.data_ini}
                            disabled
                          />
                        </div>
                      </OverlayTrigger>
                    ) : (
                      <Form.Control
                        type="date"
                        name="data_ini"
                        value={values.data_ini}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.data_ini && !!errors.data_ini}
                      />
                    )}
                    {!temItens && (
                      <Form.Control.Feedback type="invalid">
                        {errors.data_ini}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group controlId="data_fim" className="mb-3">
                    <Form.Label>Data Final *</Form.Label>
                    {temItens ? (
                      <OverlayTrigger placement="top" overlay={campoDatasTooltip}>
                        <div>
                          <Form.Control
                            type="date"
                            name="data_fim"
                            value={values.data_fim}
                            disabled
                          />
                        </div>
                      </OverlayTrigger>
                    ) : (
                      <Form.Control
                        type="date"
                        name="data_fim"
                        value={values.data_fim}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.data_fim && !!errors.data_fim}
                      />
                    )}
                    {!temItens && (
                      <Form.Control.Feedback type="invalid">
                        {errors.data_fim}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group controlId="data_limite" className="mb-3">
                <Form.Label>Data Limite</Form.Label>
                <Form.Control
                  type="date"
                  name="data_limite"
                  value={values.data_limite}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.data_limite && !!errors.data_limite}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.data_limite}
                </Form.Control.Feedback>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={onFechar} disabled={salvando}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit" disabled={salvando}>
                {salvando ? 'Salvando...' : 'Gravar'}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default FormPeriodo;
